<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    disable-auto-close
  >
    <BaseInput
      :label="
        localStorage.translations.pages['setting-work_type']['dialog-add_edit-labels']['kategoriya']
      "
      v-model="categories"
      :items="workTypeCategoryGridAll"
      item-text="name"
      item-value="id"
      multiple
      chips
      append-icon="fas fa-angle-down"
      type="select"
      :placeholder="
        localStorage.translations.pages['setting-work_type']['dialog-add_edit-labels']['kategoriya']
      "
      prepend-inner-icon="mdi-format-list-bulleted-type"
      :rules="['requiredArray']"
    />
    <BaseInput
      :label="localStorage.translations.pages['setting']['settings-finance']['code']"
      v-model="code"
      prepend-inner-icon="mdi-pound"
      :rules="['required', 'max100']"
      :placeholder="localStorage.translations.pages['setting']['settings-finance']['code']"
      :error-message="
        error.code
          ? localStorage.translations.pages.common.notifications['field_is_already_in_use']
          : ''
      "
      @input="error.code = false"
    />
    <BaseInput
      :label="
        localStorage.translations.pages['setting-work_type']['dialog-add_edit-labels']['vid-rabot']
      "
      v-model="name"
      prepend-inner-icon="mdi-hammer"
      :rules="['required', 'max100']"
      :placeholder="
        localStorage.translations.pages['setting-work_type']['dialog-add_edit-labels']['vid-rabot']
      "
      :error-message="
        error.name
          ? localStorage.translations.pages.common.notifications['name_is_already_in_use']
          : ''
      "
      @input="error.name = false"
    />
    <BaseInput
      :label="
        localStorage.translations.pages['setting-work_type']['dialog-add_edit-labels'][
          'edinitsa-izmereniya'
        ]
      "
      v-model="measure"
      prepend-inner-icon="mdi-ruler"
      :rules="['required', 'max50']"
      placeholder="m²"
    />
    <BaseInput
      :label="
        localStorage.translations.pages['setting-work_type']['dialog-add_edit-labels']['tsena']
      "
      v-model="price"
      :rules="['required']"
      input-type="Number"
      prepend-inner-icon="mdi-tag"
      append-outer-icon="euro"
      @keyup="replace()"
    />
<!--    <BaseInput
      v-if="companiesConfig.fin_system === 'netvisor'"
      :label="localStorage.translations.pages['setting-work_type']['dialog-add_edit-labels']['netvisor_key']"
      v-model="netvisorId"
      input-type="Number"
    />-->
  </TemplateModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'WorkTypeModal',
  props: {
    id: {
      type: [Number, String],
      default: -1,
    },
    create: Boolean,
  },
  data: () => ({
    name: '',
    measure: '',
    price: '',
    categories: '',
    code: '',
    netvisorId: '',
    error: {
      name: false,
      code: false,
    },
  }),
  computed: {
    ...mapGetters('workType', ['workTypeData', 'workTypeCategoryGridAll']),
    ...mapGetters(['companiesConfig']),
    workTypeCategoryGridAll() {
      return this.$store.getters['workTypeCategory/workTypeCategoryGridAll']
    },
    t() {
      return this.localStorage.translations.pages['setting-work_type']
    },
    text() {
      return {
        button: {
          open: this.t['dialog-add_edit-buttons']['dobavit'],
        },
        title: {
          create: this.t['dialog-add_edit']['sozdanie-vida-rabot'],
          edit: this.t['dialog-add_edit']['redaktirovanie-vida-rabot'],
        },
      }
    },
  },
  watch: {
    workTypeData() {
      this.name = this.workTypeData.name
      this.measure = this.workTypeData.measure
      this.price = this.workTypeData.price
      this.code = this.workTypeData.code
      this.netvisorId = this.workTypeData.netvisor_id
      if (this.workTypeData.categories) {
        this.categories = this.workTypeData.categories.map((i) => i.id)
      }
    },
  },
  methods: {
    ...mapActions('workType', [
      'onWorkTypeData',
      'onWorkTypeCreate',
      'onWorkTypeGrid',
      'onWorkTypeUpdate',
    ]),
    onWorkTypeCategoryGridAll() {
      this.$store.dispatch('workTypeCategory/onWorkTypeCategoryGridAll')
    },
    replace() {
      this.price = this.price.replace(/,/g, '.')
    },
    closeModal() {
      if (this.$refs.modal) this.$refs.modal.closeModal()
    },
    async onOpen() {
      this.onWorkTypeCategoryGridAll()
      if (this.create) {
        this.name = ''
        this.measure = ''
        this.price = ''
        this.categories = ''
        this.code = ''
        this.netvisorId = ''
      } else {
        await this.onWorkTypeData(this.id)
      }
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    async onSave() {
      if (this.create) {
        let data = {
          name: this.name,
          measure: this.measure,
          price: this.price,
          categories: this.categories,
          code: this.code,
          netvisor_id: this.netvisorId,
        }
        this.onWorkTypeCreate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications['uspeshno-dobavlen'],
                  IsError: false,
                },

                { root: true },
              )
              this.onWorkTypeGrid({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
              })
              this.closeModal()
            }
          })
          .catch((err) => {
            if (err.response.data && err.response.data.code && err.response.data.code[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'field_is_already_in_use'
                    ] +
                    ': ' +
                    this.localStorage.translations.pages['setting']['settings-finance']['code'],
                  IsError: true,
                },
                { root: true },
              )
              this.error.code = true
            } else {
              if (err.response.data && err.response.data.name && err.response.data.name[0]) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                        ],
                    IsError: true,
                  },
                  { root: true },
                )
                this.error.name = true
              }
              else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
              }
            }
          })
      } else {
        let data = {
          id: this.workTypeData.id,
          name: this.name,
          measure: this.measure,
          price: this.price,
          categories: this.categories,
          code: this.code,
          netvisor_id: this.netvisorId,
        }
        this.onWorkTypeUpdate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'izmeneniya-uspeshno-sohraneny'
                    ],
                  IsError: false,
                },

                { root: true },
              )
              this.onWorkTypeGrid({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
              })
              this.closeModal()
            }
          })
          .catch((err) => {
            if (err.response.data && err.response.data.code && err.response.data.code[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'field_is_already_in_use'
                    ],
                  IsError: true,
                },
                { root: true },
              )
              this.error.code = true
            } else {
              if (err.response.data && err.response.data.name && err.response.data.name[0]) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                        ],
                    IsError: true,
                  },
                  { root: true },
                )
                this.error.name = true
              } else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
              }
            }
          })
      }
    },
  },
}
</script>